"use client";

import { useCookieConsent } from "../cookie-consent/cookieConsentProvider";

export const YoutubeIFrame = ({ src, className }: { src: string; className: string }) => {
  const { preferences, hasSetConsent, setShowModal } = useCookieConsent();

  return hasSetConsent && preferences.marketing ? (
    <iframe
      data-cookieblock-src={src}
      data-cookieconsent="marketing"
      className={className}
      frameBorder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowFullScreen
    ></iframe>
  ) : (
    <p>
      Your current cookie consent settings prevent youtube embeds from loading. You can watch the
      video on <a href={src}>youtube</a>, or allow marketing cookies using the
      <a onClick={() => setShowModal(true)}>preferences panel</a>
    </p>
  );
};
